// @flow

import { type IncomingPayment } from './types';
import { type IncomingOneStepData } from '@tectonics/prs/one-step';

export function getOneStepData(incomingPayment: IncomingPayment): ?IncomingOneStepData {
  return incomingPayment['one_step'];
}
